import { JobUtility } from '../../../../../utilities/job.utility';
import { BasicSiteMergeData } from '../../data/basic.site.merge.data';

const address = {
    _id: '',
    street1: '123 Site St',
    suburb: 'Sydney',
    state: 'NSW',
    postcode: 2000,
    postalCode: '2000',
    county: 'County Sample',
    country: 'Australia'
};

export class FakeBasicSiteMergeData extends BasicSiteMergeData {

    constructor() {
        super();

        this.street = address.street1;
        this.suburb = address.suburb;
        this.state = address.state;
        this.postcode = `${address.postcode}`;
        this.postalCode = `${address.postcode}`;
        this.county = address.county;
        this.country = address.country;
        this.fullAddress = JobUtility.address(address);
    }

}